import type { ElementType, HTMLAttributes } from 'react'
import type { SpacingToken } from '../../styles/tokens'
import { cx } from '../cx'
import styles from './Inline.module.css'

type SpaceStep = Extract<SpacingToken, `space-${string}`>

type InlineProps = Omit<HTMLAttributes<HTMLElement>, 'style' | 'className'> & {
  as?:
    | 'div'
    | 'section'
    | 'ul'
    | 'ol'
    | 'li'
    | 'nav'
    | 'header'
    | 'footer'
    | 'main'
    | 'aside'
    | 'article'
    | 'form'
    | 'fieldset'
  gap: SpaceStep
  align?: 'center' | 'baseline' | 'start' | 'end' | 'stretch'
  justify?: 'start' | 'end' | 'between'
  wrap?: boolean
  className?: string
}

export function Inline({
  as = 'div',
  gap,
  align = 'center',
  justify,
  wrap = true,
  className,
  children,
  ...rest
}: InlineProps) {
  const Tag: ElementType = as
  return (
    <Tag
      {...rest}
      className={cx(styles.inline, className)}
      data-gap={gap}
      data-align={align}
      data-justify={justify}
      data-wrap={wrap ? undefined : 'false'}
    >
      {children}
    </Tag>
  )
}
